import Api from '../../path';
import { fetchData } from '@umu/umu-fetch'; 
 
export interface ILastLearningElement {
	homework_type: number;
	id: number;
	index: number;
	learn_status: number;
	learning_in_progress: number;
	share_url: string;
	title: string;
	type: string;
	type_name: string;
}

export const getLastLearningElement = (courseId: string): Promise<IResponse<ILastLearningElement>> => {
	return fetchData(Api.LAST_LEARNING_ELEMENT, {course_id: courseId}).then((res: IResponse<ILastLearningElement>) => {
		return res;
	});
};
 